import React from "react";
import * as c from "./lcArticleLayout.module.scss";
import LcBreadcrumbs from "./lcBreadcrumbs";
import LcContactBlock from "./lcContactBlock";
import LcArticleBody from "./lcArticleBody";
import LcFooter from "./lcFooter";
import LcTOC from "./lcTOC";
import classNames from "classnames";

export default function LcArticleLayout({
  className,
  title,
  body,
  appendBlock,
  showBreadcrumbsAndTOC = true,
  noAnchorLinks = false,
  ...props
}) {
  return (
    <>
      <div className={classNames(c.container, className, { [c.landingPage]: !showBreadcrumbsAndTOC })}>
        <div className={c.containerInner}>
          {showBreadcrumbsAndTOC && <LcBreadcrumbs className={c.breadcrumbs} {...props} />}
          <h1 className={c.title}>{title}</h1>
          {showBreadcrumbsAndTOC && <LcTOC body={body} />}
          <LcArticleBody body={body} appendBlock={appendBlock} noAnchorLinks={noAnchorLinks} />
          <LcContactBlock className={c.contactBlock} />
        </div>
      </div>
      <LcFooter />
    </>
  );
}
